import MarkdownIt from 'markdown-it';
import iterator from 'markdown-it-for-inline';
import { defaultedMarkdownLinkTargetOptions } from './markdownLinkTargetOptions';
const TRANSPARENT_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
const internalMarkdownIt = new MarkdownIt();
export const markdownLinkTarget = (md, _options = {}) => {
    md.use(iterator, 'bff_markdown_link_target', 'link_open', (tokens, index) => {
        var _a, _b;
        const options = defaultedMarkdownLinkTargetOptions(_options);
        const isInternal = (href) => {
            var _a;
            const linkHost = new URL(href).host;
            for (const strOrRegExp of (_a = options.internalHosts) !== null && _a !== void 0 ? _a : []) {
                if (typeof strOrRegExp === 'string') {
                    if (linkHost === strOrRegExp)
                        return true;
                }
                else {
                    if (strOrRegExp.test(linkHost))
                        return true;
                }
            }
            return false;
        };
        const token = tokens[index];
        const href = token.attrGet('href');
        if (href == null || !href.startsWith('http'))
            return;
        const internal = isInternal(href);
        if (internal) {
            token.attrSet('rel', 'noopener');
            token.attrSet('target', options.internalLinkTarget);
            token.attrJoin('class', options.internalLinkClass);
            if (options.internalLinkTitle) {
                token.attrSet('title', options.internalLinkTitle);
            }
        }
        else {
            token.attrSet('rel', 'noopener noreferrer');
            token.attrSet('target', options.externalLinkTarget);
            token.attrJoin('class', options.externalLinkClass);
            if (options.externalLinkTitle) {
                token.attrSet('title', options.externalLinkTitle);
            }
            if (options.externalLinkIcon) {
                const iconTokens = (_a = internalMarkdownIt.parseInline(`![${options.externalLinkTitle}](${TRANSPARENT_GIF})`, {})[0].children) !== null && _a !== void 0 ? _a : [];
                (_b = iconTokens[0]) === null || _b === void 0 ? void 0 : _b.attrJoin('class', options.externalLinkIconClass);
                tokens.splice(index + 2, 0, ...iconTokens);
            }
        }
    });
};
//# sourceMappingURL=markdownLinkTarget.js.map